<template>
  <div id="expert-footer" v-if="accountType == 5">
    <ul>
      <router-link tag="li" v-for="item in tabbars" :key="item.id" :to="item.path">
        <img class="tabbarImg" v-if="!item.active" :src="item.icon" alt="">
        <img class="tabbarImg" v-else :src="item.iconActive" alt="">
        <span>{{ item.text }}</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ExpertTabBar",
  watch: {
    '$route': {
      handler(to) {
        this.tabbars.forEach(item => {
          item.active = to.path.startsWith(item.path);
        });
      },
      deep: true,
      immediate: true,
    }
  },
  data() {
    return {
      accountType: 0,
      tabbars: [
        {
          id: 0,
          text: "发圈",
          icon: require("@assets/image/tabbar70.png"),
          iconActive: require("@assets/image/tabbar71.png"),
          path: "/expertEnd/shareMaterialLibrary",
          active: false
        },
        {
          id: 1,
          text: "数据中心",
          icon: require("@assets/image/tabbar80.png"),
          iconActive: require("@assets/image/tabbar81.png"),
          path: "/expertEnd/userBehaviorAnalysis",
          active: false
        },
        // {
        //   id: 2,
        //   text: "我的",
        //   icon: require("@assets/image/tabbar90.png"),
        //   iconActive: require("@assets/image/tabbar91.png"),
        //   path: "/expertEnd/myProfile", // 待定页面
        //   active: false
        // }
      ]
    };
  },
  mounted() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfoXpz"));
    if (userInfo && userInfo.accountType) {
      this.accountType = userInfo.accountType;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
#expert-footer {
  width: 100%;
  padding: .1rem 0 .2rem;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 103;
  border-top: 1px solid #f5f5f5;

  ul {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    li {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;

      span {
        font-size: .2rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #464646;
      }

      img {
        width: .48rem;
        height: .48rem;
      }
    }

    .router-link-active {
      span {
        color: #FE2C55;
      }
    }
  }
}
</style>
